import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  name: (<div className="text"><u>C</u>ontrols</div>),
  trigger: 'c',
  children: {
    'game_invert_controls': {
      name: (<div className="text"><u>I</u>nvert game inputs</div>),
      trigger: 'i',
    },
    'game_swap_controls': {
      name: (<div className="text"><u>S</u>wap game inputs</div>),
      trigger: 's',
    }
  }
}

/* ****************************************************************************************************************
 * Invert the game controls for the specified amount of time.
 *
 * Up goes down, left goes right, etc.
 ******************************************************************************************************************/
Blockly.Blocks['game_invert_controls'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Invert the game controls for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Invert the game controls for the specified amount of time. Up will now go down, down goes up, left goes right, etc.');
    this.showHelp = window.ShowEditorHelp(this, 'test', <div>This is a test with <u>some</u> <i>inline</i> markup!</div>);
  }
};

Blockly.JSON['game_invert_controls'] = (block) => {
  let params  = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_invert_controls',
      params
    }
  } else return;
};

Schema.registerAction('game_invert_controls', {
  "if": {
    "properties": {
      "action": {
        "const": "game_invert_controls"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Swap the game controls for the specified amount of time.
 *
 * Shooting becomes moving, and moving becomes shooting.
 ******************************************************************************************************************/
Blockly.Blocks['game_swap_controls'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Swap the game controls for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Swap the game controls for the specified amount of time. Shooting becomes moving, moving becomes shooting.');
  }
};

Blockly.JSON['game_swap_controls'] = (block) => {
  let params  = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_swap_controls',
      params
    }
  } else return;
};

Schema.registerAction('game_swap_controls', {
  "if": {
    "properties": {
      "action": {
        "const": "game_swap_controls"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});
